import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { eventsApi } from '../../_lib/api-client';
import UpgradeCard from '../../_components/UpgradeCard';

const UpgradePage: React.FC = () => {
  const navigate = useNavigate();
  const [currentEvent, setCurrentEvent] = useState<any>(null);
  const [isLoadingEvent, setIsLoadingEvent] = useState(true);

  useEffect(() => {
    // Load the current event to upgrade
    const loadCurrentEvent = async () => {
      try {
        const events = await eventsApi.getAll();
        if (events.length > 0) {
          // For now, we'll use the first event. In a real app, you'd pass the eventId
          console.log('Loaded events for upgrade page:', events);
          console.log('Selected event:', events[0]);
          setCurrentEvent(events[0]);
        }
      } catch (error) {
        console.error('Failed to load event:', error);
      } finally {
        setIsLoadingEvent(false);
      }
    };

    loadCurrentEvent();
  }, []);

  if (isLoadingEvent) {
    return (
      <div className="min-h-screen bg-gradient-to-br from-rose-50 via-white to-pink-50 flex items-center justify-center">
        <div className="text-center">
          <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-rose-500 mx-auto mb-4"></div>
          <p className="text-gray-600">Loading...</p>
        </div>
      </div>
    );
  }

  if (!currentEvent) {
    return (
      <div className="min-h-screen bg-gradient-to-br from-rose-50 via-white to-pink-50 py-12">
        <div className="max-w-md mx-auto px-4 text-center">
          <h1 className="text-2xl font-bold text-gray-900 mb-4">No Event Found</h1>
          <p className="text-gray-600 mb-6">Please create an event first before upgrading.</p>
          <button
            onClick={() => navigate('/app/events')}
            className="bg-rose-500 text-white px-6 py-2 rounded-lg hover:bg-rose-600"
          >
            Go to Events
          </button>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-gradient-to-br from-rose-50 via-white to-pink-50 py-12">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Header */}
        <div className="text-center mb-12">
          <h1 className="text-4xl font-bold text-gray-900 mb-4">
            Upgrade to Paid Event
          </h1>
          <p className="text-xl text-gray-600">
            Remove all limits and unlock premium features for your wedding
          </p>
        </div>

        {/* Upgrade Card */}
        <div className="max-w-md mx-auto">
          <UpgradeCard
            title="Upgrade to Paid Event"
            subtitle="Remove all limits and unlock premium features for your wedding"
            currentEvent={currentEvent}
          />
        </div>

        {/* Additional Information */}
        <div className="mt-12 text-center">
          <p className="text-gray-600 mb-4">
            Questions? Contact us at{' '}
            <a href="mailto:support@invitewithlove.com" className="text-rose-600 hover:underline">
              support@invitewithlove.com
            </a>
          </p>
          <button
            onClick={() => navigate(-1)}
            className="text-gray-500 hover:text-gray-700 underline"
          >
            ← Back to previous page
          </button>
        </div>
      </div>
    </div>
  );
};

export default UpgradePage;